import styled from 'styled-components';
import { colors } from 'globalStyles';
import ManageSubscriptionButton from 'containers/ManageSubscriptionButton';

// Tinted rather than alarming. This is a status the customer is meant to notice
// once and act on when convenient, not an error — LIGHT_BLUE is the codebase's
// informational tint, where RED/DANGER_BG carry the failure semantics used by
// SubscriptionRequiredNotice for an account that has already lost access.
export const Banner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 20px;
  padding: 14px 20px;
  background: ${colors.LIGHT_BLUE};
  border-left: 3px solid ${colors.MAIN_COLOR};
  border-radius: 4px;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.BODY};
`;

// The shared portal button, styled for this row. A `<button>` rather than an
// `<a>` even though it ends in a navigation, because the destination is not
// known until the server mints the session — there is no href to give a
// right-click, a middle-click, or a screen reader. Sized down from
// components/Button's default padding so the banner stays one slim row.
export const Cta = styled(ManageSubscriptionButton)`
  flex-shrink: 0;
  padding: 8px 16px;
  border: 1px solid ${colors.MAIN_COLOR};
  border-radius: 3px;
  background: ${colors.MAIN_COLOR};
  color: ${colors.WHITE};
  font-size: 12px;
  font-weight: bold;
  line-height: 17px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  // Inverts on hover/focus, matching the fill-to-outline treatment every other
  // primary control in the app uses (components/Button's buttonStyles).
  &:hover,
  &:focus-visible {
    background: ${colors.WHITE};
    color: ${colors.MAIN_COLOR};
  }

  &:focus-visible {
    outline: 2px solid ${colors.MAIN_COLOR};
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  // The one state where motion is wrong: a customer who has asked their OS for
  // less of it. Colour still carries every state above, so nothing is lost.
  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
`;
